import noop from "utilities/src/react/noop";
export const dismissNativeKeyboard = noop;
export function closeKeyboardBeforeCallback(callback) {
  callback();
}
